import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { NumberInput } from 'ui-components/components/number-input';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';
import { useAdvancedShippingNoticeContext } from '../../../../advanced-shipping-notice-context';

const QuantityCell = ({ row, isReadOnly, onChangeQuantityPerBox }) => {
  const { isHeader, boxConfigurationId, productId } = row?.original || {};
  const { quantityPerBox = 0 } = row?.values || {};

  const handleOnChangeQuantityPerBox = (newQuantity) => {
    onChangeQuantityPerBox({ boxConfigurationId, productId, newQuantity });
  };

  if (isHeader) {
    return null;
  }

  if (isReadOnly) {
    return <Text textType={TextType.Paragraph} value={quantityPerBox} />;
  }

  return <NumberInput min={1} onChange={handleOnChangeQuantityPerBox} value={quantityPerBox} />;
};

const HeaderCell = () => {
  const { isParcelConfiguration } = useAdvancedShippingNoticeContext();
  if (isParcelConfiguration) {
    return <FormattedMessage {...messages.quantityPerBox} />;
  }
  return <FormattedMessage {...messages.quantityPerPallet} />;
};

export const createQuantityPerBoxColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'quantityPerBox',
  Header: <HeaderCell />,
  Cell: QuantityCell,
  width: 1,
});
